import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MenuItem = ({ menuItem }) => {
    const [isMenuExtended, setIsMenuExtended] = useState(false);
    const [isExpandable, setIsExpandable] = useState(false);
    const [isMainActive, setIsMainActive] = useState(false);
    const [isOneOfChildrenActive, setIsOneOfChildrenActive] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();


    const toggleMenu = () => {
        setIsMenuExtended(!isMenuExtended);
    };

    const handleMainMenuAction = (item) => {
        if (isExpandable) {
            toggleMenu();
            return;
        }
        if (item && item.open) {
            window.open(item.open.url, item.open.target || '_blank')
        } else {
            navigate(item.path ? item.path : '/');
        }
    };

    const isMatchedPath = (menuPath, locPath, exact = false) => {
        let isExact = (menuPath === locPath)
        if (exact) return isExact
        let isRelated = false
        if (menuPath && locPath) {
            let i1 = menuPath.indexOf('?')
            if (i1 >= 0) {
                menuPath = menuPath.substring(0, i1)
            }
            let i2 = locPath.indexOf('?')
            if (i2 >= 0) {
                locPath = locPath.substring(0, i2)
            }
            isExact = (menuPath === locPath)
            isRelated = (menuPath && locPath.indexOf(menuPath) >= 0)
        }
        if (exact) return isExact
        return (isExact || isRelated)
    }

    const calculateIsActive = (url) => {//url: Location
        setIsMainActive(false);
        setIsOneOfChildrenActive(false);

        if (isExpandable && menuItem && menuItem.children) {
            menuItem.children.forEach((item) => {
                if (item.id === 'divider') {
                    //
                } else {
                    if (isMatchedPath(item.path, url.pathname, item.exact)) {
                        setIsOneOfChildrenActive(true);
                        setIsMenuExtended(true);
                    }
                }
            });
        } else if (isMatchedPath(menuItem.path, url.pathname, menuItem.exact)) {
            setIsMainActive(true);
        }
    }

    useEffect(() => {
        if (location) {
            calculateIsActive(location);
        }
    }, [location, isExpandable, menuItem]);

    useEffect(() => {
        if (!isMainActive && !isOneOfChildrenActive) {
            setIsMenuExtended(false);
        }
    }, [isMainActive, isOneOfChildrenActive]);

    useEffect(() => {
        setIsExpandable(
            Boolean(menuItem && menuItem.children && menuItem.children.length > 0)
        );
    }, [menuItem]);

    return (menuItem.id === 'divider' ?
        <li className={`nav-item divider ${menuItem.clazz || ''}`}></li> :
        <li className={`nav-item${isMenuExtended ? ' menu-open' : ''} ${menuItem.clazz || ''}`}>
            <a className={`nav-link${isMainActive || isOneOfChildrenActive ? ' active' : ''}`}
                role="link"
                onClick={() => { handleMainMenuAction(menuItem) }}
                style={{ cursor: 'pointer' }}
            > <i className={`${menuItem.icon}`} />
                <p className="text-truncate">{menuItem.name}</p>
                {isExpandable ? <i className="right fas fa-angle-left" /> : null}
            </a>
            {(isExpandable &&
                menuItem &&
                menuItem.children && menuItem.children.length) ?
                <ul className="nav nav-treeview">
                    {menuItem.children.map((item) => (
                        <MenuItem key={item.name + item.path}
                            menuItem={item} />
                    ))}
                </ul> : null
            }


        </li>
    );
};

export default MenuItem;